import Image from 'app/Components/Shared/Image/image';
import React  from 'react';
import Countdown from 'react-countdown';
import BtnSubmit from '../../Shared/Buttons/BtnSubmit';
import Config from '../../../Config';
import {buildUrlAndOpenWindow} from '../../../utilities/StringHelpers/StringHelpers';

const SalePackage = (props) => {
  const item = props.item;
  const COLORS = ['Black', 'Purple']


  const i = props.i;

  return (
    <div
      onClick={props.isIdf || props.isOrgPlan ? () => props.onSelectedSalePackage(item, i) : null}
      className={`swiper-item ${props.isSelectedPackage && (props.isIdf || props.isOrgPlan || props.setBorder) ? 'selected-package' : ''}`}>
      <div className='swiper-slide'>
        <div
          id={item.offerID}
          className={`package ${false ? 'selected' : ''}`}
          key={i}
          data-infrastructures={item.infrastructures}
          data-saletype={item.saleType}>
          {props.isSelectedPackage && props.isIdf && (
            <span className='badge-selected-package'>
              <svg width='26' height='26' viewBox='0 0 26 26' fill='none' xmlns='http://www.w3.org/2000/svg'>
                <path
                  fill-rule='evenodd'
                  clip-rule='evenodd'
                  d='M5.289 10.182a1.584 1.584 0 0 1 2.271 0l3.683 3.758 6.894-7.036a1.583 1.583 0 0 1 2.272 0c.627.64.627 1.678 0 2.318l-8.03 8.194c-.628.64-1.645.64-2.272 0L5.29 12.5a1.662 1.662 0 0 1 0-2.318z'
                  fill='#fff'
                />
              </svg>
            </span>
          )}
          {item.isCounter && item.counterDate ? (
            <div className='counter'>
              המבצע יסתיים בעוד - <Countdown date={item.counterDate} daysInHours={true} />
            </div>
          ) : item.benefitTitle ? (
            <div className='benefit'>
              <div
                className={[
                  'benefit-inner',
                  item.tagColor && 'benefit-inner--custom-bg',
                  item.tagColorText && 'benefit-inner--custom-text',
                ]
                  .filter(Boolean)
                  .join(' ')}
                style={{
                  ...(item.tagColor ? {backgroundColor: item.tagColor} : {}),
                  ...(item.tagColorText ? {color: item.tagColorText} : {}),
                }}>
                {item.benefitIcon && <Image width='22px' src={Config.epiBaseUrl + item.benefitIcon} alt='' />}
                <span className='benefit-text'>{item.benefitTitle}</span>
              </div>
            </div>
          ) : null}
          <div className='header' style={{backgroundColor: item.headerBackgroundColor != "" ? item.headerBackgroundColor : null}}>
            <div className={`top-header ${item.headerFourthFeatureTitle ? 'grid-view' : ''}`}>
              <div className='header-titles'>
                <div className='title' dangerouslySetInnerHTML={{__html: item.title}}></div>
                {item.subTitle && (
                  <div className='subTitle'>
                    {item.subTitleIconUrl && <Image src={Config.epiBaseUrl + item.subTitleIconUrl} />}
                    {item.subTitle}
                  </div>
                )}
              </div>
              {/*
              <div className='title' dangerouslySetInnerHTML={{ __html: item.title }}></div>
              <div className='subTitle'>
                {item.subTitleIconUrl && <img src={Config.epiBaseUrl + item.subTitleIconUrl} />}
                {item.subTitle}
              </div> */}
              {item.banner && <div className='banner'>{item.banner}</div>}
            </div>
          </div>
          <div className='body-package'>
            <div className={`bottom-header`}>
              <div className='header-features'>
                <div className='header-feature'>
                  {item.headerFirstFeatureIcon && <Image src={Config.epiBaseUrl + item.headerFirstFeatureIcon} />}
                  <div className={`${item.headerFirstFeatureIcon === undefined ? 'only-text' : ''}`}>
                    {item.headerOneTitle && <div className='title'>{item.headerOneTitle}</div>}
                    {item.headerFirstFeatureText && <div className={`text ${item.headerFirstFeatureTextBold ? 'bold': ''}`}>{item.headerFirstFeatureText}</div>}
                  </div>
                </div>
                <div className='header-feature'>
                  {item.headerSecondFeatureIcon && <Image src={Config.epiBaseUrl + item.headerSecondFeatureIcon} />}
                  <div className={`${item.headerSecondFeatureIcon === undefined ? 'only-text' : ''}`}>
                    {item.headerTwoTitle && <div className='title'>{item.headerTwoTitle}</div>}
                    {item.headerSecondFeatureText && <div className={`text ${item.headerSecondFeatureTextBold ? 'bold': ''}`}>{item.headerSecondFeatureText}</div>}
                  </div>
                </div>
                <div className='header-feature'>
                  {item.headerThirdFeatureIcon && <Image src={Config.epiBaseUrl + item.headerThirdFeatureIcon} />}
                  <div className={`${item.headerThirdFeatureIcon === undefined ? 'only-text' : ''}`}>
                    {item.headerThirdTitle && <div className='title'>{item.headerThirdTitle}</div>}
                    {item.headerThirdFeatureText && <div className={`text ${item.headerThirdFeatureTextBold ? 'bold': ''}`}>{item.headerThirdFeatureText}</div>}
                  </div>
                </div>
                <div className='header-feature'>
                  {item.headerFourthFeatureIcon && <Image src={Config.epiBaseUrl + item.headerFourthFeatureIcon} />}
                  <div className={`${item.headerFourthFeatureIcon === undefined ? 'only-text' : ''}`}>
                    {item.headerFourthTitle && <div className='title'>{item.headerFourthTitle}</div>}
                    {item.headerFourthFeatureText && <div className={`text ${item.headerFourthFeatureTextBold ? 'bold': ''}`}>{item.headerFourthFeatureText}</div>}
                  </div>
                </div>
              </div>
            </div>
            <div className='content'>
              <div className='price-content-wrapper'>
                <div className={`price-wrapper ${item.saleType == 'energy' ? 'energy-price-wrapper' : ''}`}>
                  {item.textBeforePrice && <div className={`text-before-price ${item.isTextBeforePriceCloseToPrice ? 'close-to-price' : ''}`}>{item.textBeforePrice}</div>}
                  <div className='price'>
                    {(item.saleType != 'energy' && !item.isPriceText) && <span className='currency'>₪</span>}
                    {item.price}
                  </div>
                  <div className='text'>
                    <span dangerouslySetInnerHTML={{__html: item.priceText}} />
                  </div>
                </div>
                <div className='text-under-price'>
                  {item.textBeforPriceRowTwo && <span>{item.textBeforPriceRowTwo}</span>}
                  {item.oldPriceTwo && <span className='old-price'>₪{item.oldPriceTwo}</span>}
                  {item.priceNotDel && <span>₪{item.priceNotDel}</span>}
                  {/* <span className='currency old-price'>₪</span> */}
                  {item.textUnderPrice && <div className='text-under-price'>{item.textUnderPrice}</div>}
                </div>
                {props.routerPopup && (
                  <>
                    {item.routerText && (
                      <>
                        <div className='hr'></div>
                        <p className='router-text'>
                          {item.isIncludeForeignRouter && <span className='router-icon' onClick={() => {props.onClickShowRouterDetails(item);}} role='button'/>}
                          {item.routerText}
                        </p>
                      </>
                    )}
                    {/* {item.routerText && !item.isIncludeForeignRouter && <p className='router-text'>{item.routerText}</p>} */}
                  </>
                )}
              </div>
              {!props.isIdf && item.buttonText && (
                <BtnSubmit
                  isBusiness={false}
                  text={item.buttonText}
                  onclick={() => props.onSelectedSalePackage(item)}
                  formid={'sale-packages-' + item.offerID}
                  isDisplayArrows={false}
                />
              )}
              {item.features.length > 0 && (
                <div className='features'>
                  {item.features.map((feature, i) => (
                    <div key={i} className='feature'>
                      <div className='feature-title'>{feature.title}</div>
                      {feature.featureList?.map((item, i) => (
                        <div className='feature-text' key={i}>
                          {item.iconType && <Image src={require(`./images/${item.iconType}.svg`)} alt={`${item.iconType} +  icon`} />}
                          {item.featureLink ? (
                            <a href='#' onClick={() => buildUrlAndOpenWindow(item.featureLink)}>
                              {item.text}
                            </a>
                          ) : (
                            <p
                              style={{
                                fontWeight: item.isBoldText ? 'bold' : 'regular',
                              }}>
                              {' '}
                              {item.text}{' '}
                            </p>
                          )}
                        </div>
                      ))}
                    </div>
                  ))}
                </div>
              )}
              {item.extraFeatures.length > 0 && (
                <div className='additional_info-one-time-fee'>
                  {item.extraFeatures.length > 0 && (
                    <button
                      className={`more-details-btn ${item.oneTimeFee ? 'pr-0 text-right' : 'm-auto'}`}
                      onClick={(e) => props.onClickShowMoreDetails({e, item})}>
                      {item.isShowMoreDetails ? 'סגירה' : 'למידע נוסף '}
                      <span className={`arrow ${item.isShowMoreDetails ? 'arrow-up' : 'arrow-down'}`}>
                        <span className='left-bar'></span>
                        <span className='right-bar'></span>
                      </span>
                    </button>
                  )}
                  {item.oneTimeFee && (
                    <div className={`oneTimeFee-row ${item.extraFeatures.length > 0 ? '' : 'w-100'}`}>
                      <div>{item.oneTimeFee && parseInt(item.oneTimeFee) > 0 ? `₪${item.oneTimeFee}  דמי מעבר` : `ללא דמי מעבר`}</div>
                    </div>
                  )}
                </div>
              )}
            </div>
            <div className={`content-expended ${item.isShowMoreDetails ? 'content-expended-open' : ''}`}>
              <div className='extra-features'>
                <div className='features'>
                  {item.extraFeatures?.map((feature, i) => (
                    <div key={i} className='feature'>
                      <div className='feature-title'>{feature.title}</div>
                      {feature.featureList.map((item, i) => (
                        <div key={i} className='feature-text'>
                          {item.iconType && <Image src={require(`./images/${item.iconType}.svg`)} alt={`${item.iconType} +  icon`} />}
                          {item.featureLink ? (
                            <a href='#' onClick={() => buildUrlAndOpenWindow(item.featureLink)}>
                              {item.text}
                            </a>
                          ) : (
                            <p
                              style={{
                                fontWeight: item.isBoldText ? 'bold' : 'regular',
                              }}>
                              {' '}
                              {item.text}{' '}
                            </p>
                          )}
                        </div>
                      ))}
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SalePackage;
